import { authInstance } from '@/modules/auth'
import { localStorageInstance } from '@/modules/localStorage'
import { httpCodes } from '@/modules/shared/constants/httpCodes'

export async function httpAuthenticationInterceptor(response: Response) {
  if (
    response.status !== httpCodes.FORBIDDEN &&
    response.status !== httpCodes.UNAUTHORIZED
  )
    return response

  const refreshToken = localStorageInstance.getUser()?.refreshToken
  if (!refreshToken) {
    localStorageInstance.deleteUser()
    localStorageInstance.deletePersona()
    return response
  }

  const session = await authInstance.refresh(refreshToken)
  const currentPersona = localStorageInstance.getPersona()

  localStorageInstance.setUser(session)

  if (currentPersona) {
    localStorageInstance.setPersona(
      session.personaAuthenticationResponses.find(
        (persona) => persona.personaType === currentPersona.personaType
      ) ?? currentPersona
    )
  }

  return response
}
